const t = {
  name: "ArrowRightLeftRound",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.9144 4.49991L19.5002 0.0856934L18.0859 1.49991L20.086 3.5H10.5C7.18772 3.5 4.5 6.18772 4.5 9.5C4.5 12.8123 7.18772 15.5 10.5 15.5H13V13.5H10.5C8.29228 13.5 6.5 11.7077 6.5 9.5C6.5 7.29228 8.29228 5.5 10.5 5.5H20.0858L18.0859 7.49991L19.5002 8.91412L23.9144 4.49991Z" fill="currentColor"/>
<path d="M13.5 8.5H12V10.5H13.5C15.7077 10.5 17.5 12.2923 17.5 14.5C17.5 16.7077 15.7077 18.5 13.5 18.5H3.91427L5.91436 16.4999L4.50015 15.0857L0.0859375 19.4999L4.50015 23.9141L5.91436 22.4999L3.91446 20.5H13.5C16.8123 20.5 19.5 17.8123 19.5 14.5C19.5 11.1877 16.8123 8.5 13.5 8.5Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ArrowRightLeftRound
};
